import * as React from "react";
import { getDefaultValue } from "@draftkings/sportsbook-common-utils";
import { BaseBlock } from "../../components";
import { dict } from "./dict";
import { PlayerPage } from "./ui";
import { PlayerPageState } from "./state";
import { disposer } from "../../contracts";
import { PlayerBiometricConnection, PlayerBiometricRetriever, PlayerPageParser } from "../../businessLayer/playerPage";
import { composeUrl } from "../../businessLayer/helpers";
import { MarketBoardRoot } from "../../blocks/Marketboard";
import { defaultMilestonesComponentConfig } from "./config";
import { Controller } from "@draftkings/dk-tab-switcher";
let mocks;
if (process.env.NODE_ENV === "development") {
    mocks = window["mocks"];
}
if (process.env.NODE_ENV === "test") {
    mocks = require("../../../../mocks/all");
}
export class PlayerPageRoot extends BaseBlock {
    constructor(domId, options) {
        var _a, _b;
        let playerBiometricConnection;
        const playerBiometricApi = composeUrl(options.playerBiometricApi);
        const tabSwitcherController = new Controller();
        if (process.env.NODE_ENV !== "production") {
            playerBiometricConnection = mocks.PlayerPage.PlayerBiometricConnectionMockInstance;
        }
        if (process.env.NODE_ENV === "production") {
            playerBiometricConnection = new PlayerBiometricConnection({
                apiUrl: playerBiometricApi
            });
        }
        const marketboardBlock = new MarketBoardRoot({
            apiUrl: options.sportsDataApi,
            authToken: options.token,
            consumerCommands: options.consumerCommands,
            locale: options.locale || "en-US",
            expandedSubCategoriesByDefault: 2,
            playerId: options.playerId,
            sseMaxRetryAttempts: 10,
            sseRetryInterval: 200,
            oddsStyle: options.oddsStyle,
            headerAnimation: {
                duration: 0.2,
                ease: "power2.inOut"
            },
            playerImage: options.playerImage,
            playerPageError: options.playerPageError,
            playerPagePlaceholder: options.playerPagePlaceholder,
            playerPageLink: options.playerPageLink,
            betslipSelections: options.betslipSelections,
            milestonesComponentConfig: getDefaultValue(options.milestonesComponentConfig, defaultMilestonesComponentConfig),
            productConfig: options.productConfig,
            dkDataLayer: options.dkDataLayer,
            onMobileToggleSelection: getDefaultValue(options.onMobileToggleSelection, disposer),
            isMobile: getDefaultValue(options.isMobile, () => false),
            trackEvent: getDefaultValue(options.trackEvent, () => {
            }),
            featureFlags: options.featureFlags,
            getTeamLogo: options.getTeamLogo,
            logos: options.logos,
            isPlayerImageDisabled: options.isPlayerImageDisabled,
            s3AssetHost: options.s3AssetHost,
            tabSwitcherController,
            consumerVersion: options.consumerVersion,
            requestTimeout: options.requestTimeout,
            messageBus: options.messageBus,
            localizationConfig: options.localizationConfig
        });
        super(domId, new PlayerPageState({
            playerId: options.playerId,
            parser: new PlayerPageParser({
                dict: Object.assign(Object.assign({}, dict), (((_a = options.localizationConfig) === null || _a === void 0 ? void 0 : _a.playerPage) || {})),
                logError: options.consumerCommands.logError,
                retriever: new PlayerBiometricRetriever({
                    connection: playerBiometricConnection,
                    playerBiometricData: options.playerBiometricData,
                    setCanonicalMetadata: options.setCanonicalMetadata
                }),
                productConfig: options.productConfig,
                featureFlags: options.featureFlags
            }),
            playerImage: options.playerImage,
            marketboardBlock,
            dict: Object.assign(Object.assign({}, dict), (((_b = options.localizationConfig) === null || _b === void 0 ? void 0 : _b.playerPage) || {})),
            playerBiometricData: options.playerBiometricData,
            tabSwitcherController,
            productConfig: options.productConfig,
            isPlayerImageDisabled: options.isPlayerImageDisabled,
            trackEvent: getDefaultValue(options.trackEvent, () => { }),
            consumerVersion: getDefaultValue(options.consumerVersion, ""),
        }));
        this.marketboardBlock = marketboardBlock;
        this.component = React.createElement(PlayerPage, Object.assign({}, { dataProvider: this.dataProvider }));
        this.setOddsStyle = this.setOddsStyle.bind(this);
        this.addSelections = this.addSelections.bind(this);
        this.removeSelections = this.removeSelections.bind(this);
        this.setParams = this.setParams.bind(this);
    }
    setOddsStyle(oddsStyle) {
        this.marketboardBlock.setOddsStyle(oddsStyle);
    }
    addSelections(data) {
        this.marketboardBlock.addSelections(data);
    }
    removeSelections(data) {
        this.marketboardBlock.removeSelections(data);
    }
    setParams(params) {
        this.dataProvider.setParams(params);
        this.marketboardBlock.setParams(params);
    }
}
window["PlayerPage"] = PlayerPageRoot;
//# sourceMappingURL=index.js.map